import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PlaceServices from "../../services/externalServices/TourPackageServices/placeServices";
import {
  Box,
  Typography,
  Divider,
  Chip,
  Stack,
  TextField,
  Button,
  Grid,
  FormControlLabel,
  Switch,
  Card,
  CardMedia,
  CardContent,
  Paper,
  Snackbar,
  Alert,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
} from "@mui/material";
import SpotServices from "../../services/externalServices/TourPackageServices/spotServices";

function PlaceDetail() {
  const { id } = useParams(); // Access the place ID from the URL
  const [place, setPlace] = useState(null);
  const [isEditing, setIsEditing] = useState(false); // Track edit mode
  const [editedPlace, setEditedPlace] = useState(null); // Store edited place data
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const [spots, setSpots] = useState([]);

  useEffect(() => {
    fetchPlaceDetails();
    fetchSpots();
  }, [id, isEditing]);

  const fetchPlaceDetails = async () => {
    try {
      const response = await PlaceServices.getPlaceById(id);
      setPlace(response);
      setEditedPlace(response); // Initialize editedPlace with the fetched data
    } catch (error) {
      console.log("error getting place details", error);
    }
  };
  const fetchSpots = async () => {
    try {
      const response = await SpotServices.getAllSpots();
      setSpots(response);
      console.log("Spots for place:", response);
    } catch (error) {
      console.log("error getting spots for place", error);
    }
  };

  // Function to handle input change when editing
  //   const handleInputChange = (e) => {
  //     const { name, value } = e.target;
  //     setEditedPlace({ ...editedPlace, [name]: value });
  //   };
  const handleInputChange_sjd = (e, field, index) => {
    const { name, value, type, checked } = e.target;

    if (Array.isArray(editedPlace[field])) {
      // If the field is an array (like nearbyPlaces, tips, etc.)
      const updatedField = [...editedPlace[field]]; // Clone the array
      updatedField[index] = value; // Update the specific index
      setEditedPlace((prevState) => ({ ...prevState, [field]: updatedField }));
    } else {
      // If the field is not an array (like fullName, description, etc.)
      setEditedPlace((prevState) => ({ ...prevState, [name]: value }));
    }

    console.log("editedPlace", editedPlace);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    console.log("e.target", name);
    const language = selectedLanguage; // Use the current selected language here
    // console.log("checked value",checked)
    if (name === "location") {
      setEditedPlace((prev) => ({
        ...prev,
        location: {
          ...prev.location,
          [e.target.dataset.field]: value,
        },
      }));
    } else if (name.startsWith("sliderImages")) {
      const fieldName = name.split("-")[0];
      const index = parseInt(name.split("-")[1], 10);
      const updatedArray = [...editedPlace[fieldName]];
      updatedArray[index] = value;
      setEditedPlace((prev) => ({
        ...prev,
        [fieldName]: updatedArray,
      }));
    } else if (
      name.startsWith("nearbyPlaces") ||
      name.startsWith("tags") ||
      name.startsWith("rules") ||
      name.startsWith("tips")
    ) {
      // For fields like nearbyPlaces, tags, or rules that have array values
      const fieldName = name.split("-")[0];
      console.log("fieldName", fieldName);
      const index = parseInt(name.split("-")[1], 10); // Assuming the index of the array item
      setEditedPlace((prev) => ({
        ...prev,
        [fieldName]: {
          ...prev[fieldName],
          [language]: [
            ...prev[fieldName][language].slice(0, index),
            value, // Update the specific item at the index
            ...prev[fieldName][language].slice(index + 1), // Ensure the other items remain intact
          ],
        },
      }));
    } else if (
      name.includes("fullName") ||
      name.includes("shortName") ||
      name.includes("description") ||
      name.includes("message") ||
      name.includes("openTimings")
    ) {
      const fieldName = name.split("-")[0];
      setEditedPlace((prev) => ({
        ...prev,
        [fieldName]: {
          ...prev[fieldName],
          [selectedLanguage]: value, // Update the specific language field
        },
      }));
    } else if (name === "requiresEntryFee") {
      setEditedPlace((prev) => ({
        ...prev,
        [name]: checked, // Here we directly use 'checked' which is a boolean value
      }));
    } else if (name.startsWith("audioGuide")) {
      const parts = name.split("-");
      const [, maybeLengthType, maybeField] = parts;

      if (["short", "medium", "long"].includes(maybeLengthType)) {
        // ✅ Handle audioGuide-short-audioUrl
        const lengthType = maybeLengthType;
        const field = maybeField;

        setEditedPlace((prev) => ({
          ...prev,
          audioGuide: {
            ...prev.audioGuide,
            [language]: {
              ...prev.audioGuide?.[language],
              [lengthType]: {
                ...prev.audioGuide?.[language]?.[lengthType],
                [field]: value,
              },
            },
          },
        }));
      } else {
        // ✅ Handle audioGuide-name, audioGuide-language, audioGuide-isEnabled
        const field = maybeLengthType;
        const newValue = field === "isEnabled" ? checked : value;

        setEditedPlace((prev) => ({
          ...prev,
          audioGuide: {
            ...prev.audioGuide,
            [language]: {
              ...prev.audioGuide?.[language],
              [field]: newValue,
            },
          },
        }));
      }
    } else {
      setEditedPlace((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // Function to toggle edit mode
  const toggleEditMode = () => {
    setIsEditing(!isEditing);
  };

  // Function to save edited place details
  const saveChanges = async () => {
    try {
      await PlaceServices.updatePlace(id, editedPlace);
      setPlace(editedPlace); // Update the place with the edited details
      setIsEditing(false); // Exit edit mode
      setSuccessMessage("Place details updated successfully!");
    } catch (error) {
      console.log("error saving place details", error);
      setErrorMessage("Failed to update Place details. Please try again.");
    }
  };
  const handleLanguageChange = (e) => {
    setSelectedLanguage(e.target.value); // Update selected language
  };

  if (!place) return <Typography>Loading...</Typography>;

  return (
    <Box sx={{ p: 5 }}>
      {/* Title and thumbnail */}

      {/* Language Selection Dropdown */}
      <Grid container spacing={4} sx={{ mb: 3 }}>
        <Grid item>
          <FormControl fullWidth sx={{ mb: 3 }}>
            <InputLabel>Language</InputLabel>
            <Select
              value={selectedLanguage}
              onChange={handleLanguageChange}
              label="Language"
            >
              <MenuItem value="en">English</MenuItem>
              <MenuItem value="kn">Kannada</MenuItem>
              <MenuItem value="te">Telugu</MenuItem>
              <MenuItem value="ta">Tamil</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item>
          <Button variant="contained" color="primary" onClick={toggleEditMode}>
            {isEditing ? "Cancel" : "Edit"}
          </Button>
        </Grid>
      </Grid>
      <Grid container spacing={4} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6}>
          {isEditing ? (
            <Grid item xs={12}>
              <TextField
                label="Thumbnail Image URL"
                name="thumbnailImage"
                value={editedPlace.thumbnailImage || ""}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
              />
            </Grid>
          ) : (
            <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
              <CardMedia
                component="img"
                height="300"
                image={place.thumbnailImage}
                alt={place.shortName[selectedLanguage]}
                sx={{ objectFit: "cover" }}
              />
            </Card>
          )}
        </Grid>

        <Grid item xs={12} sm={6}>
          <CardContent>
            <Typography variant="h6" sx={{ fontWeight: 500 }} gutterBottom>
              Full Name
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
              {isEditing ? (
                <TextField
                  name="fullName"
                  value={editedPlace.fullName[selectedLanguage]}
                  onChange={handleInputChange}
                  fullWidth
                  variant="outlined"
                />
              ) : (
                place.fullName[selectedLanguage]
              )}
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 500 }} gutterBottom>
              Short Name
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
              {isEditing ? (
                <TextField
                  name="shortName"
                  value={editedPlace.shortName[selectedLanguage]}
                  onChange={handleInputChange}
                  fullWidth
                  variant="outlined"
                />
              ) : (
                place.shortName[selectedLanguage]
              )}
            </Typography>
          </CardContent>
        </Grid>
      </Grid>

      <Divider sx={{ my: 2 }} />

      {/* Description Section */}
      <Typography variant="h6" sx={{ fontWeight: 500 }} gutterBottom>
        Description
      </Typography>
      <Typography variant="body1" paragraph sx={{ mb: 3 }}>
        {isEditing ? (
          <TextField
            name="description"
            value={editedPlace.description[selectedLanguage]}
            onChange={handleInputChange}
            fullWidth
            multiline
            rows={4}
            variant="outlined"
          />
        ) : (
          place.description[selectedLanguage]
        )}
      </Typography>

      <Divider sx={{ my: 2 }} />

      {/* Location & Timings */}
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" sx={{ fontWeight: 500 }} gutterBottom>
            Location
          </Typography>

          {isEditing ? (
            <Box sx={{ mb: 3 }}>
              <TextField
                label="Latitude"
                value={editedPlace.location.latitude}
                onChange={(e) =>
                  setEditedPlace((prevState) => ({
                    ...prevState,
                    location: {
                      ...prevState.location,
                      latitude: e.target.value,
                    },
                  }))
                }
                fullWidth
                sx={{ mb: 2 }}
              />
              <TextField
                label="Longitude"
                value={editedPlace.location.longitude}
                onChange={(e) =>
                  setEditedPlace((prevState) => ({
                    ...prevState,
                    location: {
                      ...prevState.location,
                      longitude: e.target.value,
                    },
                  }))
                }
                fullWidth
                sx={{ mb: 2 }}
              />
            </Box>
          ) : (
            <>
              <Typography variant="body1" sx={{ mb: 3 }}>
                Latitude: {place.location.latitude}
              </Typography>
              <Typography variant="body1" sx={{ mb: 3 }}>
                Longitude: {place.location.longitude}
              </Typography>
            </>
          )}
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography variant="h6" sx={{ fontWeight: 500 }} gutterBottom>
            Open Timings
          </Typography>
          {isEditing ? (
            <TextField
              name="openTimings"
              value={editedPlace.openTimings[selectedLanguage]}
              onChange={handleInputChange}
              fullWidth
              variant="outlined"
            />
          ) : (
            place.openTimings[selectedLanguage]
          )}
        </Grid>
      </Grid>

      <Divider sx={{ my: 2 }} />

      {/* Nearby Places */}
      <Typography variant="h6" sx={{ fontWeight: 500 }} gutterBottom>
        Nearby Places
      </Typography>
      {isEditing ? (
        <>
          {place.nearbyPlaces[selectedLanguage]?.map((nearby, index) => (
            <TextField
              key={index}
              value={editedPlace.nearbyPlaces[selectedLanguage][index]} // Use the editedPlace array
              onChange={handleInputChange} // Pass the correct field and index// Handle specific tip changes
              label={`Place ${index + 1}`}
              fullWidth
              sx={{ mb: 2 }}
              name={`nearbyPlaces-${index}`}
            />
          ))}
        </>
      ) : (
        <Stack direction="row" spacing={1} sx={{ mb: 3 }}>
          {place.nearbyPlaces[selectedLanguage]?.map((nearby, index) => (
            <Chip key={index} label={nearby} color="primary" />
          ))}
        </Stack>
      )}

      <Divider sx={{ my: 2 }} />

      {/* Entry Fee */}
      <Typography variant="h6" sx={{ fontWeight: 500 }} gutterBottom>
        Entry Fee
      </Typography>
      {isEditing ? (
        <FormControlLabel
          control={
            <Switch
              checked={editedPlace.requiresEntryFee}
              onChange={handleInputChange}
              name="requiresEntryFee"
            />
          }
          label={editedPlace.requiresEntryFee ? "Required" : "Free"}
        />
      ) : place.requiresEntryFee ? (
        "Required"
      ) : (
        "Free"
      )}

      <Divider sx={{ my: 2 }} />

      {/* Tips and Rules */}
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" sx={{ fontWeight: 500 }} gutterBottom>
            Tips
          </Typography>
          {isEditing ? (
            <>
              {place.tips[selectedLanguage]?.map((tip, index) => (
                <TextField
                  key={index}
                  value={
                    editedPlace.tips
                      ? editedPlace.tips[selectedLanguage][index]
                      : tip
                  } // Use editedPlace if editing
                  onChange={handleInputChange} // Handle specific tip changes
                  label={`Tips ${index + 1}`}
                  fullWidth
                  sx={{ mb: 2 }}
                  name={`tips-${index}`} // Unique name for each field
                />
              ))}
            </>
          ) : (
            <ul>
              {place.tips[selectedLanguage]?.map((tip, index) => (
                <li key={index}>{tip}</li>
              ))}
            </ul>
          )}
        </Grid>

        {/* Rules Section */}
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" sx={{ fontWeight: 500 }} gutterBottom>
            Rules
          </Typography>
          {isEditing ? (
            <>
              {place.rules[selectedLanguage]?.map((rule, index) => (
                <TextField
                  key={index}
                  value={
                    editedPlace.rules
                      ? editedPlace.rules[selectedLanguage][index]
                      : rule
                  } // Use editedPlace if editing
                  onChange={handleInputChange} // Handle specific rule changes
                  label={`Rule ${index + 1}`}
                  fullWidth
                  sx={{ mb: 2 }}
                  name={`rules-${index}`} // Unique name for each field
                />
              ))}
            </>
          ) : (
            <ul>
              {place.rules[selectedLanguage]?.map((rule, index) => (
                <li key={index}>{rule}</li>
              ))}
            </ul>
          )}
        </Grid>
      </Grid>

      <Divider sx={{ my: 2 }} />

      <Typography variant="h6" sx={{ fontWeight: 500 }} gutterBottom>
        Tags
      </Typography>
      {isEditing ? (
        <Box>
          <Stack direction="row" spacing={1} sx={{ mb: 3 }}>
            {place.tags[selectedLanguage]?.map((tag, index) => (
              <TextField
                key={index}
                value={
                  editedPlace.tags
                    ? editedPlace.tags[selectedLanguage][index]
                    : tag
                } // Use editedPlace if editing
                onChange={handleInputChange} // Handle specific tag changes
                label={`Tag ${index + 1}`}
                fullWidth
                sx={{ mb: 2 }}
                name={`tags-${index}`} // Unique name for each field
              />
            ))}
          </Stack>
        </Box>
      ) : (
        <Stack direction="row" spacing={1} sx={{ mb: 3 }}>
          {place.tags[selectedLanguage]?.map((tag, index) => (
            <Chip key={index} label={tag} color="secondary" />
          ))}
        </Stack>
      )}

      <Divider sx={{ my: 2 }} />

      {/* Message */}
      <Typography variant="h6" sx={{ fontWeight: 500 }} gutterBottom>
        Message
      </Typography>
      {isEditing ? (
        <TextField
          name="message"
          value={editedPlace.message[selectedLanguage]}
          onChange={handleInputChange}
          fullWidth
          variant="outlined"
        />
      ) : (
        place.message[selectedLanguage]
      )}

      <Divider sx={{ my: 2 }} />

      {/* Visit Time */}
      <Typography variant="h6" sx={{ fontWeight: 500 }} gutterBottom>
        Visit Time
      </Typography>
      {isEditing ? (
        <TextField
          name="approxVisitTime"
          value={editedPlace.approxVisitTime}
          onChange={handleInputChange}
          fullWidth
          variant="outlined"
        />
      ) : (
        place.approxVisitTime
      )}

      <Divider sx={{ my: 2 }} />

      {/* Enabled Status */}
      <Typography variant="h6" sx={{ fontWeight: 500 }} gutterBottom>
        Enabled
      </Typography>
      {isEditing ? (
        <TextField
          select
          name="isEnabled"
          value={editedPlace.isEnabled}
          onChange={handleInputChange}
          fullWidth
          variant="outlined"
          SelectProps={{
            native: true, // Use this for a native dropdown look
          }}
        >
          <option value={true}>Yes</option>
          <option value={false}>No</option>
        </TextField>
      ) : place.isEnabled ? (
        "Yes"
      ) : (
        "No"
      )}

      {/* Audio Guide */}
      <Divider sx={{ my: 2 }} />
      <Typography variant="h6" sx={{ fontWeight: 500 }} gutterBottom>
        Audio Guide
      </Typography>

      {isEditing ? (
        <>
          {/* Add top-level fields for selected language here */}
          <TextField
            label="Audio Guide Name"
            fullWidth
            sx={{ mb: 2 }}
            name="audioGuide-name"
            value={editedPlace.audioGuide?.[selectedLanguage]?.name || ""}
            onChange={handleInputChange}
          />

          <TextField
            label="Language Code"
            fullWidth
            sx={{ mb: 2 }}
            name="audioGuide-language"
            value={editedPlace.audioGuide?.[selectedLanguage]?.language || ""}
            onChange={handleInputChange}
          />

          <FormControlLabel
            control={
              <Checkbox
                name="audioGuide-isEnabled"
                checked={
                  !!editedPlace.audioGuide?.[selectedLanguage]?.isEnabled
                }
                onChange={handleInputChange}
              />
            }
            label="Is Enabled"
            sx={{ mb: 2 }}
          />

          {/* Continue with short/medium/long sections */}
          {["short", "medium", "long"].map((lengthType) => (
            <React.Fragment key={lengthType}>
              <Typography variant="subtitle1" gutterBottom>
                {lengthType.charAt(0).toUpperCase() + lengthType.slice(1)}{" "}
                Version
              </Typography>
              <TextField
                label="Audio URL"
                fullWidth
                sx={{ mb: 2 }}
                name={`audioGuide-${lengthType}-audioUrl`}
                value={
                  editedPlace.audioGuide?.[selectedLanguage]?.[lengthType]
                    ?.audioUrl || ""
                }
                onChange={handleInputChange}
              />
              <TextField
                label="Subtitles URL"
                fullWidth
                sx={{ mb: 3 }}
                name={`audioGuide-${lengthType}-subtitlesUrl`}
                value={
                  editedPlace.audioGuide?.[selectedLanguage]?.[lengthType]
                    ?.subtitlesUrl || ""
                }
                onChange={handleInputChange}
              />
            </React.Fragment>
          ))}
        </>
      ) : (
        <>
          {/* View-only mode */}
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            Name: {place.audioGuide?.[selectedLanguage]?.name || "-"}
          </Typography>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Language Code:{" "}
            {place.audioGuide?.[selectedLanguage]?.language || "-"}
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Enabled:{" "}
            {place.audioGuide?.[selectedLanguage]?.isEnabled ? "Yes" : "No"}
          </Typography>

          {["short", "medium", "long"].map((lengthType) => {
            const audio =
              place.audioGuide?.[selectedLanguage]?.[lengthType] || {};
            if (!audio.audioUrl && !audio.subtitlesUrl) return null;

            return (
              <div key={lengthType} style={{ marginBottom: 16 }}>
                <Typography variant="subtitle1" gutterBottom>
                  {lengthType.charAt(0).toUpperCase() + lengthType.slice(1)}{" "}
                  Version
                </Typography>
                {audio.audioUrl && (
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    🎧 Audio:{" "}
                    <a
                      href={audio.audioUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {audio.audioUrl}
                    </a>
                  </Typography>
                )}
                {audio.subtitlesUrl && (
                  <Typography variant="body2">
                    📄 Subtitles:{" "}
                    <a
                      href={audio.subtitlesUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {audio.subtitlesUrl}
                    </a>
                  </Typography>
                )}
              </div>
            );
          })}
        </>
      )}

      <Divider sx={{ my: 2 }} />

      <Typography variant="h6" sx={{ fontWeight: 500, mt: 4 }} gutterBottom>
        Spots Included
      </Typography>

      {isEditing ? (
        <Stack spacing={2} sx={{ backgroundColor: "white" }}>
          {(spots || []).map((spot) => {
            const isSelected = editedPlace.spotsIncluded?.some(
              (s) => s.spotId._id === spot._id
            );
            const spotName = spot.name?.[selectedLanguage] || "Unnamed";
            const thumbnail = spot.thumbnailImage;
            const selectedSpot = editedPlace.spotsIncluded?.find(
              (s) => s.spotId._id === spot._id
            );

            return (
              <Stack
                key={spot._id}
                direction="row"
                spacing={2}
                alignItems="center"
                sx={{
                  p: 2,
                  border: "1px solid #ccc",
                  borderRadius: 2,
                  backgroundColor: isSelected ? "#e8f5e9" : "#fafafa",
                }}
              >
                <Checkbox
                  checked={isSelected}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setEditedPlace((prev) => {
                      const current = prev.spotsIncluded || [];
                      if (checked) {
                        return {
                          ...prev,
                          spotsIncluded: [
                            ...current,
                            {
                              spotId: spot,
                              sequence: current.length + 1,
                              isEnabled: true,
                            },
                          ],
                        };
                      } else {
                        return {
                          ...prev,
                          spotsIncluded: current.filter(
                            (s) => s.spotId._id !== spot._id
                          ),
                        };
                      }
                    });
                  }}
                />

                <img
                  src={
                    thumbnail ||
                    "https://via.placeholder.com/80x80?text=No+Image"
                  }
                  alt={spotName}
                  style={{
                    width: 80,
                    height: 80,
                    objectFit: "cover",
                    borderRadius: 8,
                    backgroundColor: "#eee",
                  }}
                />

                <Stack sx={{ flexGrow: 1 }}>
                  <Typography variant="subtitle1">{spotName}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {spot.description}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Lat: {spot.location?.latitude}, Lng:{" "}
                    {spot.location?.longitude}
                  </Typography>

                  {isSelected && (
                    <Stack
                      direction="row"
                      spacing={2}
                      alignItems="center"
                      sx={{ mt: 1 }}
                    >
                      <TextField
                        label="Sequence"
                        type="number"
                        size="small"
                        value={selectedSpot?.sequence || ""}
                        onChange={(e) => {
                          const newSequence = parseInt(e.target.value);
                          setEditedPlace((prev) => ({
                            ...prev,
                            spotsIncluded: prev.spotsIncluded.map((s) =>
                              s.spotId._id === spot._id
                                ? { ...s, sequence: newSequence }
                                : s
                            ),
                          }));
                        }}
                        sx={{ width: 100 }}
                        inputProps={{ min: 1 }}
                      />

                      <FormControlLabel
                        control={
                          <Switch
                            checked={selectedSpot?.isEnabled ?? true}
                            onChange={(e) => {
                              setEditedPlace((prev) => ({
                                ...prev,
                                spotsIncluded: prev.spotsIncluded.map((s) =>
                                  s.spotId._id === spot._id
                                    ? { ...s, isEnabled: e.target.checked }
                                    : s
                                ),
                              }));
                            }}
                          />
                        }
                        label="Enabled"
                        labelPlacement="start"
                      />
                    </Stack>
                  )}
                </Stack>
              </Stack>
            );
          })}
        </Stack>
      ) : (
        // Your existing non-editing view
        <Stack spacing={2}>
          {(place.spotsIncluded || [])
            .slice()
            .sort((a, b) => a.sequence - b.sequence)
            .map((spot, index) => {
              const { spotId, sequence, isEnabled } = spot;
              const spotName = spotId.name?.[selectedLanguage] || "Unnamed";
              const thumbnail = spotId.thumbnailImage;

              return (
                <Stack
                  key={spotId._id}
                  direction="row"
                  spacing={2}
                  alignItems="center"
                  sx={{
                    mb: 2,
                    p: 2,
                    border: "1px solid #e0e0e0",
                    borderRadius: 2,
                    backgroundColor: isEnabled ? "#f9f9f9" : "#f5f5f5",
                    opacity: isEnabled ? 1 : 0.5,
                  }}
                >
                  <img
                    src={
                      thumbnail ||
                      "https://via.placeholder.com/80x80?text=No+Image"
                    }
                    alt={spotName}
                    style={{
                      width: 80,
                      height: 80,
                      objectFit: "cover",
                      borderRadius: 8,
                      backgroundColor: "#eee",
                    }}
                  />
                  <Stack spacing={0.5}>
                    <Typography variant="subtitle1">
                      {sequence}. {spotName}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {spotId.description}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Lat: {spotId.location?.latitude}, Lng:{" "}
                      {spotId.location?.longitude}
                    </Typography>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Chip
                        label={`Sequence: ${sequence}`}
                        size="small"
                        variant="outlined"
                      />
                      <Chip
                        label={isEnabled ? "Enabled" : "Disabled"}
                        size="small"
                        color={isEnabled ? "success" : "error"}
                      />
                    </Stack>
                  </Stack>
                </Stack>
              );
            })}
        </Stack>
      )}

      <Divider sx={{ my: 2 }} />

      <Typography variant="h6" sx={{ fontWeight: 500 }} gutterBottom>
        Slider Images
      </Typography>
      {isEditing ? (
        <>
          {editedPlace.sliderImages?.map((image, index) => (
            <TextField
              key={`sliderImage-${index}`}
              label={`Slider Image ${index + 1} URL`}
              name={`sliderImages-${index}`}
              value={image || ""} // Ensure fallback for undefined
              onChange={handleInputChange}
              fullWidth
            />
          ))}
        </>
      ) : (
        <Grid container spacing={2}>
          {place.sliderImages?.map((image, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card>
                <CardMedia
                  component="img"
                  height="200"
                  image={image}
                  alt={`Slider Image ${index + 1}`}
                />
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Feature Media */}
      <Divider sx={{ my: 2 }} />
      <Typography variant="h6" sx={{ fontWeight: 500 }} gutterBottom>
        Feature Media
      </Typography>
      {isEditing ? (
        <Box sx={{ mb: 3 }}>
          <TextField
            name="featureMediaType"
            value={editedPlace.featureMediaType}
            onChange={handleInputChange}
            fullWidth
            variant="outlined"
            helperText="Enter media type (e.g., image, video)"
            sx={{ mb: 2 }}
          />
          <TextField
            name="featureMediaURL"
            value={editedPlace.featureMediaURL}
            onChange={handleInputChange}
            fullWidth
            variant="outlined"
            helperText="Enter feature media URL"
          />
        </Box>
      ) : (
        <>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Media Type: {place.featureMediaType || "N/A"}
          </Typography>
          {place.featureMediaURL && (
            <Card sx={{ borderRadius: 2, boxShadow: 3, mb: 2 }}>
              <CardMedia
                component={
                  place.featureMediaType === "video" ? "iframe" : "img"
                }
                height="300"
                src={place.featureMediaURL}
                alt="Feature Media"
                sx={{ objectFit: "cover" }}
              />
            </Card>
          )}
        </>
      )}

      {/* Internal Comments */}
      <Divider sx={{ my: 2 }} />
      <Typography variant="h6" sx={{ fontWeight: 500 }} gutterBottom>
        Internal Comments
      </Typography>
      {isEditing ? (
        <TextField
          name="internalComments"
          value={editedPlace.internalComments}
          onChange={handleInputChange}
          fullWidth
          multiline
          rows={2}
          variant="outlined"
        />
      ) : (
        <Typography variant="body1" paragraph>
          {place.internalComments}
        </Typography>
      )}

      {/* Created At & Updated At */}
      {/* <Divider sx={{ my: 2 }} />
      <Typography variant="h6" sx={{ fontWeight: 500 }} gutterBottom>
        Metadata
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        Created At: {new Date(place.createdAt.$date).toLocaleString()}
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        Updated At: {new Date(place.updatedAt.$date).toLocaleString()}
      </Typography> */}

      {/* Action buttons */}
      <Grid container spacing={2} sx={{ mt: 3 }}>
        <Grid item>
          <Button variant="contained" color="primary" onClick={toggleEditMode}>
            {isEditing ? "Cancel" : "Edit"}
          </Button>
        </Grid>
        {isEditing && (
          <Grid item>
            <Button variant="contained" color="secondary" onClick={saveChanges}>
              Save Changes
            </Button>
          </Grid>
        )}
      </Grid>

      {/* Success and Error Messages */}
      <Snackbar
        open={Boolean(successMessage)}
        autoHideDuration={3000}
        onClose={() => setSuccessMessage("")}
      >
        <Alert
          onClose={() => setSuccessMessage("")}
          severity="success"
          sx={{ width: "100%" }}
        >
          {successMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        open={Boolean(errorMessage)}
        autoHideDuration={3000}
        onClose={() => setErrorMessage("")}
      >
        <Alert
          onClose={() => setErrorMessage("")}
          severity="error"
          sx={{ width: "100%" }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default PlaceDetail;
